import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { styled } from "@mui/system";

/* ================= FONT LOAD ================= */
const FontStyles = () => (
  <style>
    {`
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Inter+Tight:wght@400;500;600;700&family=Playfair+Display:ital@1&display=swap');
    `}
  </style>
);

/* ================= IMAGE ================= */
const BG_IMAGE =
  "https://qleen.bold-themes.com/demo-01/wp-content/uploads/sites/2/2025/07/hero_about.jpg";

/* ================= HERO ================= */
const HeroWrapper = styled(Box)(() => ({
  position: "relative",
  minHeight: "90vh",
  display: "flex",
  alignItems: "center",
  backgroundImage: `url(${BG_IMAGE})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  overflow: "hidden",

  /* LIGHT LEFT GRADIENT (as per screenshot) */
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(90deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.30) 45%, rgba(0,0,0,0.05) 100%)",
    zIndex: 1,
  },
}));

/* ================= COMPONENT ================= */
export default function AboutHeroSection() {
  return (
    <>
      <FontStyles />

      <HeroWrapper>
        <Container
          maxWidth="xl"
          sx={{
            position: "relative",
            zIndex: 2,
            pt: { xs: 10, md: 14 }, // pushes content slightly down
          }}
        >
          <Grid container>
            <Grid item xs={12} lg={7}>
              <Box sx={{ maxWidth: 760, color: "#fff" }}>
                {/* ABOUT US (SCRIPT STYLE) */}
                <Typography
                  sx={{
                    fontFamily: "'Playfair Display', serif",
                    fontStyle: "italic",
                    fontSize: "1.2rem",
                    mb: 2,
                    opacity: 0.95,
                  }}
                >
                  About us
                </Typography>

                {/* MAIN HEADLINE */}
                <Typography
                  sx={{
                    fontFamily: "Inter Tight, sans-serif",
                    fontWeight: 600, // 🔑 lighter weight
                    lineHeight: 1.12,
                    letterSpacing: "-0.01em",
                    fontSize: {
                      xs: "2.7rem",
                      sm: "3.4rem",
                      md: "4rem",
                      lg: "4.6rem",
                    },
                  }}
                >
                  Restoring More Than Just Homes 
                  <br />
                  We Restore Lives.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} lg={5} />
          </Grid>
        </Container>
      </HeroWrapper>
    </>
  );
}
